import { Injectable } from '@angular/core';
import { BaseHubConnection } from './base-hub-connection.service';
import { TagLocationModel } from './models/tag-location.model';
import { BehaviorSubject } from 'rxjs';
import { GlobalVariablesService } from '../global-variables.service';
import { HubConnectionState } from '@microsoft/signalr';

@Injectable({
  providedIn: 'root'
})
export class LocationHubConnectionService extends BaseHubConnection {
  private locationUpdatedSubject: BehaviorSubject<TagLocationModel> = new BehaviorSubject<TagLocationModel>(null);
  public locationUpdated$ = this.locationUpdatedSubject.asObservable();
  private hubUrlCandidates: string[] = [];
  private activeHubUrlIndex = 0;


  constructor(private globals: GlobalVariablesService) {

    super();



  }

  public init() {
    this.hubUrlCandidates = [
      this.globals.buildTrackerUrl('/location-hub'),
    ];
    this.activeHubUrlIndex = 0;
    this.initializeHubConnection(this.hubUrlCandidates[this.activeHubUrlIndex], this.webSocketOnlyOptions({ withCredentials: true }));

    this.connectionStatus.subscribe((status) => {

    }
    );
    this.bindLocationUpdatedHandler();
  }

  private bindLocationUpdatedHandler(): void {
    this.hubConnection.off('LocationUpdated');
    this.hubConnection.on("LocationUpdated", (data: any) => {

      const location = new TagLocationModel(data);
      this.locationUpdatedSubject.next(location);
    });
  }

  public override async startConnection() {
    if (!this.hubUrlCandidates.length) {
      this.init();
    }

    for (let index = this.activeHubUrlIndex; index < this.hubUrlCandidates.length; index++) {
      this.activeHubUrlIndex = index;
      this.initializeHubConnection(this.hubUrlCandidates[index], this.webSocketOnlyOptions({ withCredentials: true }));
      this.bindLocationUpdatedHandler();
      await super.startConnection();

      if (this.currentState === HubConnectionState.Connected) {
        return;
      }
    }
  }

}
